<template>
    <div class="outcall-task">
        <div class="head">
            <span class="title">号码分组</span>
            <span @click="goBack" style="display: inline-block;width:64px;height:32px;background: rgba(255, 255, 255, 1);line-height: 32px;text-align: center;float:right;color:rgba(121, 136, 155, 1);border-radius: 4px;margin:8px 0 0 8px;cursor: pointer;border: 1px solid rgba(121, 136, 155, 1);">返回</span>
            <span @click="addNumberGroup" style="display: inline-block;width:64px;height:32px;background: rgba(24, 144, 255, 1);line-height: 32px;text-align: center;float:right;color:#fff;border-radius: 4px;margin:8px 0 0 8px;cursor: pointer;;">新增</span>
            <a-icon type="exclamation-circle" />
        </div>
        <div class="content">
            <div class="content-in">
                <!-- <div class="modular-content">
                    <div class="modular-in">

                    </div>
                </div> -->
                <div v-for="(item,index) in groupList" :key="index" style="padding: 20px 24px;background:#fff;border-radius: 4px;margin-bottom: 16px;">
                    <div style="height: 42px;border-bottom: 1px solid rgba(229, 229, 229, 1);">
                        <span>{{item.name}}</span>
                        <div style="float: right;">
                            <span @click="editGroup(item)" style="display: inline-block;width:64px;height:32px;display: inline-block;border:1px solid rgba(121, 136, 155, 1);color:rgba(121, 136, 155, 1);line-height: 30px;text-align: center;border-radius: 4px;cursor: pointer;;">编辑</span>
                            <span @click="deleteGroup(item.id)" style="display: inline-block;width:64px;height:32px;display: inline-block;border:1px solid rgba(121, 136, 155, 1);color:rgba(121, 136, 155, 1);line-height: 30px;text-align: center;border-radius: 4px;margin-left:8px;cursor: pointer;">删除</span>
                        </div>
                    </div>
                    <div style="color:rgba(0, 0, 0, 1);font-size: 14px;overflow-wrap: break-word;margin-top:16px;;">
                        {{ item.numbers }}
                    </div>
                    <div style="margin-top:24px;">
                        <div style="display: inline-block;">
                            <span style="color:rgba(188, 188, 188, 1);font-size:12px;">总计： 号码数量：</span>
                            <span style="color:rgba(24, 144, 255, 1);font-size:12px;">{{item.numberCount}}</span>
                        </div>
                        <div style="display: inline-block;float: right;color:rgba(188, 188, 188, 1);font-size: 12px;">
                                                                     创建人：{{item.createBy}}    
                            <span style="margin: 0 8px;">|</span>    创建时间：{{item.createTime}}    
                            <span style="margin: 0 8px;">|</span>    修改人：{{item.updateBy}}    
                            <span style="margin: 0 8px;">|</span>    修改时间：{{ item.updateTime }}
                        </div>
                    </div>
                </div>
                <div style="height: 1px;"></div>
            </div>
        </div>
        <a-drawer
            title=''
            placement="right"
            :closable="true"
            :visible="drawerVisible"
            :destroyOnClose='true'
            :maskClosable='true'
            @close="onClose"
            :width='768'
            :mask='true'
            :headerStyle="{ border: 'none', height: '56px', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '0'}"
            :bodyStyle="{ background: 'rgba(240, 242, 243, 1)', height: '100%', position: 'absolute', width: '100%', left: '0', top: '0', zIndex: '10', padding: '0 0 0' }"
        >
            <div class="drawer-sence drawer-public">
                <div class="drawer-head">
                    <div class="drawer-title">
                        <span class="left">{{carryType}}号码分组</span>
                        <div class="right" style="margin-top:6px;">
                            <a-icon @click="onClose" type="close" />
                        </div>
                    </div>
                   
                </div>
                <div class="drawer-content">
                    <div class="drawer-body-content">
                        <div style="color:rgba(188, 188, 188, 1);font-size:12px;">输入分组名称：</div>
                        <a-input v-model="groupName" style="margin-top: 11px;" placeholder="请输入组名称" />
                        <div style="color:rgba(188, 188, 188, 1);font-size:12px;margin-top:24px;">选择号码：</div>
                        <div style="margin-top:17px;">
                            <span style="color:rgba(80, 80, 80, 1);font-size: 14px;">已选择</span>
                            <span style="color:rgba(24, 144, 255, 1);font-size: 14px;margin:0 4px">{{ selectedRowKeys1.length }}</span>
                            <span style="color:rgba(80, 80, 80, 1);font-size: 14px;">个</span>
                            <a-icon @click="showSelectedModal" style="color:rgba(121, 136, 155, 0.5);margin-left: 24px;cursor: pointer;font-size:16px;" type="zoom-in" />
                        </div>
                    </div>
                </div>
                <div class="drawer-foot">
                    <div class="btn-group">
                        <a-button type="primary" ghost @click="cancelInfoDrawer">取消</a-button>
                        <a-button type="primary" @click="saveDrawer">提交</a-button>
                    </div>
                </div>
            </div>
        </a-drawer>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="chooseAccountModal" :closable='false' footer='' :zIndex='10000000' width='1020px'>
            <div class="choose-account-modal">
                <div class="add-title">
                    <span>选择号码</span>
                    <a-icon @click="cancelChooseAccount" type="close" />
                </div>
                <div class="choose-account-data">
                    <a-row>
                        <a-col :span="15">
                            <div class="account-left-content">
                                <div class="sort-condition">
                                    <a-input v-model="searchNum" @input='inputChange()' placeholder="搜索号码" />
                                </div>
                                <div class="account-table">
                                    <a-table
                                        :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1 }"
                                        :columns="columns1"
                                        :data-source="numberData1"
                                        :pagination='false'
                                        :scroll="{ x: '100%', y: '240'}"
                                        :rowKey="(record,index)=>{return record.id}"
                                    >
                                    </a-table>
                                    
                                </div>
                                <div class="pagination-table">
                                    <a-pagination
                                        show-size-changer
                                        :total="totalNumber"
                                        :show-total="totalNumber => `共 ${totalNumber} 条     `"
                                        v-model="currentPage2"
                                        @change="pageChange2"
                                        @showSizeChange="onShowSizeChange2"
                                        :pageSizeOptions="['10', '50', '100', '200']"
                                    />
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="9">
                            <div class="account-right-content">
                                <div class="choosed-title">
                                    <div style="display: inline-block;color: rgba(153, 153, 153, 1);font-size: 14px;">已选择：
                                        <span style="color:rgba(24, 144, 255, 1);font-size:14px">{{ selectedRowKeys1.length }}</span>
                                        个号码
                                    </div>
                                    <span style="color: rgba(24, 144, 255, 1);font-size: 14px;float: right;cursor: pointer;" @click="cleanSelected">清空</span>
                                </div>
                                <div class="choosed-content">
                                    <div class="choosed-item" v-for="(item,index) in selectedRowKeys1" :key='index'>
                                        <a-icon class="choosed-phone" type="phone" />
                                        <span class="choosed-number">{{dataObj[item]['number']}}</span>
                                        <a-icon class="choosed-close" @click="deleteSelectedNum(index)" type="close" />
                                    </div>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelChooseAccount">取消</a-button>
                        <a-button type="primary" @click="sureChooseAccount">确定</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteModal" footer='' width='480px'>
            <div class="delete-modal modal-public">
                <div class="sure-off-bind">
                    <a-icon type="warning" />
                    <span>您确定要删除这个分组吗？</span>
                </div>
                <div class="tip">删除后，数据无法恢复</div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group2">
                    <a-button ghost @click="cancelDelete">取消</a-button>
                    <a-button type="primary" @click="sureDelete">确认</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>

    export default {
        name: 'OutCallTask',
        components: { },
        data () {
            return {
                moduleId: '',
                drawerVisible: false,
                chooseAccountModal: false,
                selectedRowKeys1: [],
                searchNum: '',
                columns1: [
                     {
                        dataIndex: 'id',
                        key: 'id',
                        title: 'id',
                        colSpan: 0,
                        customRender: () => {
                            return {
                                attrs: {
                                    colSpan: 0,
                                },
                            };
                        },
                    },
                    {
                        dataIndex: 'number',
                        scopedSlots: {
                            customRender: 'number'
                        },
                        key: 'number',
                        title: '号码'
                    },
                    {
                        dataIndex: 'expirationDate',
                        scopedSlots: {
                            customRender: 'expirationDate'
                        },
                        key: 'expirationDate',
                        title: '有效期'
                    },
                    {
                        dataIndex: 'remark',
                        scopedSlots: {
                            customRender: 'remark'
                        },
                        key: 'remark',
                        title: '备注'
                    },
                ],
                numberData1: [],
                totalNumber: 0,
                currentPage2: 1,
                pageSize2: 10,
                sortField: '',
                sortMode: '',
                dataObj: {},
                groupList: [],
                currentId: '',
                groupName: '',
                groupNumberList: [],
                deleteModal: false,
                carryType: '新增'
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onClose() {
                this.drawerVisible = false
            },
            cancelInfoDrawer() {
                this.drawerVisible = false
                this.groupName = ''
                this.selectedRowKeys1 = []
                this.currentId = ''
            },
            saveDrawer() {
                this.drawerVisible = false
                this.axios.post('/api/numberGroup/saveGroup', {
                    groupId: this.currentId,
                    name: this.groupName,
                    numberIdList: this.selectedRowKeys1
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('成功')
                        this.groupName = ''
                        this.selectedRowKeys1 = []
                        this.currentId = ''
                        this.queryGroupList()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            addNumberGroup() {
                this.currentId = ''
                this.carryType = '新增'
                this.drawerVisible = true
            },
            showSelectedModal() {
                if(this.currentId == ''){
                    this.dataObj = {}
                    this.selectedRowKeys1 = []
                    this.currentPage2 = 1
                    this.pageSize2 = 10
                    this.queryNumber(1)
                }
                this.chooseAccountModal = true
            },
            cancelChooseAccount() {
                this.chooseAccountModal = false
            },
            sureChooseAccount() {
                this.chooseAccountModal = false
                
            },
            onSelectChange1(selectedRowKeys) {
                this.selectedRowKeys1 = selectedRowKeys;
            },
            cleanSelected() {
                this.selectedRowKeys1 = []
            },
            deleteSelectedNum(index) {
                this.selectedRowKeys1.splice(index, 1);
            },
            pageChange2(current, pageSize) {
                this.currentPage2 = current
                this.pageSize2 = pageSize
                this.queryNumber(2)
            },
            onShowSizeChange2(current, pageSize) {
                this.currentPage2 = current
                this.pageSize2 = pageSize
                this.queryNumber(2)
            },
            queryGroupList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/numberGroup/list', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        console.log(response.data.data)
                        this.groupList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            editGroup(item) {
                // console.log(item.id)
                this.selectedRowKeys1 = []
                this.currentId = item.id
                this.carryType = '编辑'
                this.drawerVisible = true
                this.groupName = item.name
                this.currentPage2 = 1
                this.pageSize2 = 1000//此处不可修改，需要把所有数据全部请求出来做匹配
                this.queryNumber(1)
            },
            deleteGroup(id) {
                this.currentId = id
                this.deleteModal = true
            },
            queryNumber(type) {//type属性区分是初始化查询，还是搜索或者下一页查询，如果是初始化查询，则清空已选数据，否则不需要清空已选号码。1为初始化，2为翻页或者搜索
                this.axios(
                    {
                        method:'get',
                        url:'/api/numberGroup/numberList', 
                        params:{
                            groupId: this.currentId,
                            number: this.searchNum,
                            current: this.currentPage2,
                            size: this.pageSize2,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        let arr = response.data.data.groupNumberList
                        if(type == 1){
                            this.selectedRowKeys1 = []
                        }
                        // for(let i = 0; i < arr.length; i++){
                        //     this.selectedRowKeys1.push(arr[i]['id'])
                        // }
                        for (let i = 0; i < arr.length; i++) {
                            let id = arr[i]['id']
                            if (!this.selectedRowKeys1.includes(id)) {
                                this.selectedRowKeys1.push(id)
                            }
                        }
                        let brr = response.data.data.allNumberList.records
                        for(let i = 0; i < brr.length; i++){
                            this.dataObj[brr[i]['id']] = brr[i]
                        }
                        this.groupNumberList = response.data.data.groupNumberList
                        this.numberData1 = response.data.data.allNumberList.records
                        this.totalNumber = response.data.data.allNumberList.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            inputChange() {
                this.queryNumber(2)
            },
            cancelDelete() {
                this.deleteModal = false
            },
            sureDelete() {
                this.deleteModal = false
                this.axios.post('/api/numberGroup/deleteGroup', {
                    groupId: this.currentId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('删除成功')
                        this.currentId = ''
                        this.queryGroupList()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        mounted: function() {
            this.sessionData('set','personalCenter','numberManage');
            this.moduleId = this.$route.query.moduleId
            this.queryGroupList()

        }
    }
</script>

<style scoped lang="less">
    .outcall-task{
        height: 100%;
        position: relative;
        .head{
            height: 48px;
            line-height: 48px;
            padding: 0 24px;
            background: #fff;
            border-left: 1px solid #e8ebee;
            z-index: 100;
            position: absolute;
            left: 0px;
            top: 0px;
            width: 100%;
            button{
                float: right;
                height: 32px;
                margin: 8px 0 0 8px;
            }
            .title{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
            i{
                float: right;
                margin-top: 16px;
                font-size: 16px;
                color: rgba(204, 204, 204, 1);
                cursor: pointer;
            }
        }
        .content{
            position: absolute;
            padding: 16px;
            left: 0px;
            top: 0px;
            height: 100%;
            padding-top: 64px;
            width: 100%;
            overflow-y: auto;
            .content-in{
                width: 100%;
                height: 100%;
                position: relative;
                .modular-content{
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    height: 100%;
                    width: 100%;
                    border-radius: 4px;
                    .modular-in{
                        width: 100%;
                        height: 100%;
                        background: #fff;
                        border-radius: 4px;
                        overflow-y: auto;
                        padding: 24px;
                    }
                }
            }  
        }
    }
    .drawer-public{
        height: 100%;
        position: relative;
        padding-bottom: 60px;
        .drawer-title{
            height: 55px;
            width: 100%;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
                line-height: 55px;
            }
            i{
                color: rgba(153, 153, 153, 1);
                font-size: 16px;
                margin-left: 16px;
                cursor: pointer;
                line-height: 50px;
            }
        }
        .drawer-head{
            height: 56px;
            background: #fff;
            padding: 0 24px 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            z-index: 100;

        }
        .drawer-content{
            padding: 71px 16px 68px 16px;
            width: 100%;
            height: 100%;
            position: absolute;
        }
        .drawer-foot{
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            height: 52px;
            background: #fff;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            .btn-group{
                text-align: center;
                padding-top: 10px;
                width: 100%;
                button{
                    height: 32px;
                    font-size: 14px;
                }
                button:nth-child(2){
                    margin: 0 16px;
                }
            }
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .btn-group{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                margin-right: 16px;
            }
        }
        .btn-group2{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }
    .drawer-sence{
        .row-head{
            padding-top: 20px;
            border-top: 1px solid rgba(229, 229, 229, 1);
            .col-left{
                div:nth-child(1){
                    color: rgba(188, 188, 188, 1);
                    font-size: 12px;
                }
                div:nth-child(2){
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                    margin-top: 6px;
                }
            }
        }
        .drawer-body-content{
            width: 100%;
            height: 100%;
            border-radius: 4px;
            overflow-y: auto;
            padding: 24px;
            background: #fff;
        }
    }
    .choose-account-modal{
        .add-title{
            padding: 20px 0 14px 0px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .choose-account-data{
            padding: 24px 0;
            .account-left-content{
                padding-right: 24px;
                border-right: 1px solid rgba(229, 229, 229, 1);
                .account-table{
                    margin-top: 24px;
                    max-height: 400px;
                    overflow-y: auto;
                }
                .pagination-table{
                    float: right;
                    padding-top: 24px;
                }
                .sort-condition{
                    input{
                        width: 350px;
                    }
                    .sort-list{
                        display: inline-block;
                        padding: 0 12px;
                        height: 32px;
                        line-height: 32px;
                        background: #fafafa;
                        margin-left: 10px;
                        font-size: 14px;
                        cursor: pointer;
                        border-radius: 4px;
                    }
                    span.active{
                        background: #1890FF;
                        color: #fff;
                    }
                }
            }
            .account-right-content{
                padding-left: 24px;
                // .choosed-title{
                //     span:nth-child(1){
                //         color: rgba(153, 153, 153, 1);
                //         font-size: 14px;
                //     }
                //     span:nth-child(2){
                //         color: rgba(24, 144, 255, 1);
                //         font-size: 14px;
                //         float: right;
                //         cursor: pointer;
                //     }
                // }
                .choosed-content{
                    margin-top: 24px;
                    max-height: 305px;
                    overflow-y: auto;
                    .choosed-item{
                        display: inline-block;
                        min-width: 132px;
                        height: 32px;
                        margin: 0 8px 8px 0;
                        background: rgba(121, 136, 155, 0.1);
                        text-align: center;
                        line-height: 32px;
                        padding: 0 8px;
                        .choosed-phone{
                            color: rgba(121, 136, 155, 1);
                            font-size: 16px;
                            float: left;
                            margin-top: 7px;
                        }
                        .choosed-number{
                            color: rgba(80, 80, 80, 1);
                            font-size: 14px;
                            display: inline-block;
                            min-width: 84px;
                            overflow: hidden;
                        }
                        .choosed-close{
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                            float: right;
                            margin-top: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 0 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .delete-modal{
        padding-top: 24px;
        padding-bottom: 48px;
        .sure-off-bind{
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 20px;
                margin-left: 24px;
            }
        }
        .tip{
            color: rgba(80, 80, 80, 1);
            padding-left: 50px;
            margin: 24px 0;
        }
    }
    /deep/ .ant-table-header{
        overflow-y: overlay !important;
    }
</style>